<div class="row">
  <div class="col-11 col-sm-12 col-lg-4" *ngFor="let sdk of sortByField('sdksTitle', sdkDetails)">
    <div class="sdk-details d-flex">
      <a class="text-truncate" target="_blank" [attr.href]="sdk.sdksWebsite">
        <span class="sdkTitle" [title]="sdk.sdksTitle">
          <img class="mr-2" src="https://cdn.pixalate.com/sdk/icons/{{sdk.sdksWebsite | extractDomain}}.png" width="16"
            height="16" onerror="this.src='/assets/images/sdk-missing-icon.png';" alt="SDK Icon" />
          {{ sdk.sdksTitle }}</span>
        <i class='fa fa-external-link ml-1' aria-hidden='true' [title]="sdk.sdksWebsite"></i>
      </a>
      <span class="ml-auto text-truncate" [title]="sdk.sdksTags">({{ sdk.sdksTags }})</span>
    </div>
  </div>
</div>